import { withSession } from '@zipdrug/react-api-sdk';
import withSsoLogin from 'hoc/withSsoLogin';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, SubmissionError } from 'redux-form';
import { useNavigate } from 'react-router-dom';
import { setSiteDownBypass } from '../redux/queryReducer';
import SiteDownForm from './SiteDownForm';

const ReduxSiteDownBypass = reduxForm({
  form: 'site-down-bypass',
})(SiteDownForm);

const SiteDownContainer = ({ setSiteDownBypass, siteBypass, withSiteBypass }) => {
  const navigate = useNavigate();

  const handleSubmit = ({ passcode }) =>
    siteBypass({ passcode })
      .catch(e => {
        let _error = 'No connection';
        if (e.graphQLErrors && e.graphQLErrors.length) {
          _error = e.graphQLErrors[0].message;
        }
        throw new SubmissionError({ _error });
      })
      .then(res => {
        if (res.data && !res.errors) {
          setSiteDownBypass({ bypass: true });
          Cookies.set('site_down_bypass', true);
          navigate('/signin');
        } else {
          throw new SubmissionError({ _error: 'Invalid code' });
        }
      });

  return (
    <>{withSiteBypass && <ReduxSiteDownBypass onSubmit={handleSubmit} />}</>
  );
};

SiteDownContainer.propTypes = {
  setSiteDownBypass: PropTypes.func,
  siteBypass: PropTypes.func,
  withSiteBypass: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  setSiteDownBypass: ({ bypass }) => dispatch(setSiteDownBypass({ bypass })),
});

export default compose(
  withSsoLogin,
  withSession,
  connect(null, mapDispatchToProps),
)(SiteDownContainer);